/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authorized_Apps_NoneInputs */



/**
* | output |
* | --- |
* | "No authorized apps" |
*
* @param {Authorized_Apps_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const authorized_apps_none = /** @type {((inputs?: Authorized_Apps_NoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authorized_Apps_NoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune application autorisée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ninguna aplicación autorizada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum aplicativo autorizado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna applicazione autorizzata")
	return /** @type {LocalizedString} */ ("No authorized apps")
});